import AuthAPI from "./auth";
import ClientsAPI from "./clients";
import AudiencesAPI from "./audiences";
import NotificationAPI from "./notifications";
import UserAPI from "./user";
import SubscriptionAPI from "./subscriptions";
import PaymentsAPI from "./payments";
import PlatformsAPI from "./platforms";
import CRMAPI from "./crm";

export default class API {
  static auth = AuthAPI;

  static client = ClientsAPI;

  static notification = NotificationAPI;

  static user = UserAPI;

  static audience = AudiencesAPI;

  static subscription = SubscriptionAPI;

  static payments = PaymentsAPI;

  static platforms = PlatformsAPI;

  static crm = CRMAPI;
}
